import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { MasterdataService } from "@core-services/masterdata.service";
import { combineLatest, Observable } from "rxjs";
import { KYC_EDIT_DETAILS_SUPPORT_FORM_SELECTED } from "@helpers/constants";
import { SegmentService } from "@main-services/segment.service";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";
import { UpdateInfoUserType } from "@modules/shared/modals/change-personal-info/constants/user-info-constants.model";
import { UserInfoRouteNames } from "@modules/shared/modals/change-personal-info/domain/entities/change-user-info.model";
import { UserVM } from "@modules/new_account/features/new_account-profile/components/new_account-profile-container.component";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "kyc-customer-data-update",
	templateUrl: "./kyc-customer-data-update.component.html",
	styleUrls: ["./kyc-customer-data-update.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class KycCustomerDataUpdateComponent {
	private readonly profile$ = this.newProfileFacade.getProfile$();

	public readonly UserVM$: Observable<UserVM> = combineLatest({
		profile: this.profile$,
		location: this.newProfileFacade.getLocations$
	});
	public readonly infoUserType = UpdateInfoUserType;

	@Input() public sliderAvailable: boolean = true;
	@Output() public editClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public closeModal = new EventEmitter<void>();

	public constructor(
		private newProfileFacade: NewProfileFacade,
		private masterdataService: MasterdataService,
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	public getCountry(countryCode: string): string {
		if (countryCode) {
			return this.masterdataService.getCountryById(countryCode)?.getName();
		}
		return "";
	}

	public changeAddress(dataType: UpdateInfoUserType): void {
		this.onButtonClick();
		this.newProfileFacade.navigateToPathAndQp(UserInfoRouteNames.Address, { kycFlow: true });
		this.closeModal.emit();
	}

	public changePhoneNumber(dataType: UpdateInfoUserType): void {
		this.onButtonClick();
		this.newProfileFacade.navigateToPathAndQp(UserInfoRouteNames.PhoneNumber, { kycFlow: true });
		this.closeModal.emit();
	}

	public changeEmailAddress(dataType: UpdateInfoUserType): void {
		this.onButtonClick();
		this.newProfileFacade.navigateToPath(UserInfoRouteNames.EmailAddress);
		this.closeModal.emit();
	}

	public changePersonalInformation(dataType: UpdateInfoUserType): void {
		this.onButtonClick();
		this.goToHelpDesk(dataType);
	}

	public goToHelpDesk(dataType: UpdateInfoUserType): void {
		this.newProfileFacade.goToHelpDesk(dataType);
	}

	public onButtonClick(): void {
		this.editClicked.emit(true);
		this.segmentService.track({ name: KYC_EDIT_DETAILS_SUPPORT_FORM_SELECTED });
		this.rudderstackService.track({ name: KYC_EDIT_DETAILS_SUPPORT_FORM_SELECTED });
	}
}
